// Use current domain for API calls — prevents CORS issues when domain changes
const isLocalhost = typeof window !== 'undefined' && window.location.hostname === 'localhost';
const BACKEND_URL = isLocalhost
  ? (process.env.REACT_APP_BACKEND_URL || window.location.origin)
  : window.location.origin;
export { BACKEND_URL };
export const API = `${BACKEND_URL}/api`;

// === ENGAGEMENT TYPES ===
export const ENGAGEMENT_TYPES = [
  { id: "Commercial Opportunity", label: "Commercial Opportunity" },
  { id: "Strategic Entry", label: "Strategic Entry" },
  { id: "Paid Diagnostic / Pilot", label: "Paid Diagnostic / Pilot" },
  { id: "Partnership", label: "Partnership" },
];

// === LOCKED STAGES (REX Commercial Lifecycle Specification v1.0) ===

export const STAGES = [
  // A. Pre-Revenue Pipeline (Commercial)
  { id: "Unqualified Leads", label: "Unqualified Leads", color: "bg-slate-400", group: "pre-revenue" },
  { id: "First Contact Made", label: "First Contact Made", color: "bg-blue-400", group: "pre-revenue" },
  { id: "Discovery Conversation Held", label: "Discovery Conversation", color: "bg-blue-500", group: "pre-revenue" },
  { id: "RFP Received", label: "RFP Received", color: "bg-indigo-500", group: "pre-revenue" },
  { id: "Diagnostic / Briefing Phase", label: "Diagnostic / Briefing", color: "bg-violet-500", group: "pre-revenue" },
  { id: "Non-Financial Proposal Sent", label: "Non-Financial Proposal", color: "bg-fuchsia-500", group: "pre-revenue" },
  { id: "Proposal Submitted", label: "Proposal Submitted", color: "bg-amber-500", group: "pre-revenue" },
  { id: "Commercial Negotiation", label: "Commercial Negotiation", color: "bg-orange-500", group: "pre-revenue" },
  { id: "Verbal Agreement", label: "Verbal Agreement", color: "bg-lime-500", group: "pre-revenue" },
  { id: "Contract Signed", label: "Contract Signed", color: "bg-emerald-500", group: "pre-revenue" },
  // B. Post-Revenue (Engagement Lifecycle)
  { id: "Onboarding", label: "Onboarding", color: "bg-teal-500", group: "post-revenue" },
  { id: "Delivery in Progress", label: "Delivery in Progress", color: "bg-cyan-500", group: "post-revenue" },
  { id: "Delivery Completed", label: "Delivery Completed", color: "bg-sky-500", group: "post-revenue" },
  { id: "Expansion / Upsell Discussion", label: "Expansion / Upsell", color: "bg-purple-500", group: "post-revenue" },
  // C. Strategic Entry Path
  { id: "Strategic Entry Proposed", label: "SE Proposed", color: "bg-teal-400", group: "strategic-entry" },
  { id: "Strategic Entry Delivered", label: "SE Delivered", color: "bg-teal-600", group: "strategic-entry" },
  { id: "Expansion Conversation", label: "Expansion Conversation", color: "bg-purple-400", group: "strategic-entry" },
  // D. Closed States
  { id: "Closed \u2013 Won", label: "Closed \u2013 Won", color: "bg-green-600", group: "closed" },
  { id: "Closed \u2013 Not Proceeding", label: "Closed \u2013 Not Proceeding", color: "bg-red-500", group: "closed" },
];

export const STAGE_GROUPS = {
  "pre-revenue": { label: "Pre-Revenue Pipeline", stages: STAGES.filter(s => s.group === "pre-revenue") },
  "post-revenue": { label: "Post-Revenue", stages: STAGES.filter(s => s.group === "post-revenue") },
  "strategic-entry": { label: "Strategic Entry", stages: STAGES.filter(s => s.group === "strategic-entry") },
  "closed": { label: "Closed", stages: STAGES.filter(s => s.group === "closed") },
};

// === LOCKED STATUSES ===
export const CLIENT_STATUSES = [
  { id: "Active", label: "Active", color: "bg-green-500", description: "Live movement within last 30 days" },
  { id: "Dormant", label: "Dormant", color: "bg-slate-500", description: "No movement in 30+ days" },
  { id: "On Hold", label: "On Hold", color: "bg-amber-500", description: "Explicitly paused" },
  { id: "Closed", label: "Closed", color: "bg-red-500", description: "Terminal state" },
];

// === PROBABILITY MODEL (Fixed — Users cannot edit) ===
export const STAGE_PROBABILITIES = {
  "RFP Received": 0.20,
  "Proposal Submitted": 0.40,
  "Commercial Negotiation": 0.60,
  "Verbal Agreement": 0.80,
  "Contract Signed": 1.00,
};

// === CURRENCIES ===
export const CURRENCIES = ["NGN", "USD", "GBP", "EUR", "GHS", "KES", "XOF"];

export const TIERS = ["Tier 1", "Tier 2", "Tier 3"];

export const SECTORS = [
  "Financial Services",
  "Technology",
  "Healthcare",
  "Manufacturing",
  "Retail",
  "Energy",
  "Telecommunications",
  "Professional Services",
  "Other"
];

export const CONFIDENCE_LEVELS = ["High", "Medium", "Low"];

// Stages that require opportunity_value + expected_close_date (Commercial Opportunity only)
export const REVENUE_REQUIRED_STAGES = [
  "Proposal Submitted", "Commercial Negotiation", "Verbal Agreement", "Contract Signed",
  "Onboarding", "Delivery in Progress", "Delivery Completed", "Expansion / Upsell Discussion",
  "Closed \u2013 Won",
];

// Stages included in pipeline value calculations
export const PIPELINE_STAGES = ["RFP Received", "Proposal Submitted", "Commercial Negotiation", "Verbal Agreement"];

// Stages for signed revenue
export const SIGNED_REVENUE_STAGES = ["Contract Signed", "Delivery in Progress", "Delivery Completed"];
